export const ALL_REVIEW = "ALL_REVIEW";
export const CREATE_REVIEW = "CREATE_REVIEW";
export const DELETE_REVIEW = "DELETE_REVIEW";
export const ERROR_REVIEW = "ERROR_REVIEW";
export const RESET_LOADING = "RESET_LOADING";
export const CLEAR_ERROR = "CLEAR_ERROR";
